import React from 'react';

function XIcon({
  size,
  stroke
}) {
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={size? size : "h-6 w-6"}  fill="none" viewBox="0 0 24 24" stroke={stroke}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>  
  )
}

export default XIcon
